import React from 'react'

const portifolioError = (payload) => {
  if (typeof payload === 'object' && payload !== null) {
    if (payload.error) {
      if (typeof payload.error !== 'object') {
        return payload.error
      } else {
        return (payload.error.messages && payload.error.messages[0].text) ||
          `${payload.message}${payload.details && payload.details !== 'null' ? `: ${payload.details}` : ''}`
      }
    } else {
      return (payload.messages && payload.messages[0].text) ||
      `${payload.message}${payload.details && payload.details !== 'null' ? `: ${payload.details}` : ''}`
    }
  } else {
    return payload
  }
  // return (typeof payload === 'object' && payload !== null)
  //   ? ((typeof payload.error !== 'object') ? payload.error : ((payload.error.messages && payload.error.messages[0].text) ||
  //   `${payload.message}${payload.details && payload.details !== 'null' ? `: ${payload.details}` : ''}`))
  //   : payload
}

export default (payload) =>
  <div className='connect-error-alert'>{portifolioError(payload)}</div>



// WEBPACK FOOTER //
// ./src/elements/error-block.js